import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TitleBar } from "../components/index.js";
import { getGreatPotions, getPotions } from "../logic/Logic.js";

const ListPotions = ({}) => {
  const [infos, setInfos] = useState({});

  useEffect(() => {
    list();
  }, []);

  const list = async () => {
    const ret = { potions: getPotions(), greatPotions: getGreatPotions() };
    setInfos(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Potions"}>
      <br></br>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Die Roll</th>
            <th>Item</th>
            <th>purchasePrice</th>
            <th>SalePrice</th>
          </tr>
        </thead>
        <tbody>
          {infos?.potions?.map((obj) => {
            return (
              <tr>
                <td>{obj["dieroll"]}</td>
                <td>
                  <Tooltip title={obj.effects} arrow slotProps={{ tooltip: { sx: { fontSize: "1rem" } } }}>
                    <span>{obj.item}</span>
                  </Tooltip>
                </td>
                <td>{obj.purchasePrice}</td>
                <td>{obj.SalePrice}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <br></br>
      <br></br>
      <br></br>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Die Roll</th>
            <th>Item</th>
            <th>Purchase Price</th>
            <th>Sale Price</th>
            <th>Ingredient Cost</th>
          </tr>
        </thead>
        <tbody>
          {infos?.greatPotions?.map((obj) => {
            return (
              <tr>
                <td>{obj["dieroll"]}</td>
                <td>
                  <Tooltip
                    title={obj.effects}
                    arrow
                    slotProps={{
                      tooltip: {
                        sx: { fontSize: "1rem" },
                      },
                    }}
                  >
                    <span>{obj.item}</span>
                  </Tooltip>
                </td>
                <td>{obj.purchasePrice}</td>
                <td>{obj.SalePrice}</td>
                <td>{obj["Ingredient Cost"]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(ListPotions);
